import { Map, List } from 'immutable';

import {
  updateMatchStatus,
  OPEN_UPDATE_MATCH_STATUS_MODAL,
  CLOSE_UPDATE_MATCH_STATUS_MODAL,
  REQUEST_OFFER_UPLOAD,
  REQUEST_OFFER_UPLOAD_SUCCESS,
  REQUEST_OFFER_UPLOAD_FAILURE,
  REQUEST_OFFER_UPLOAD_PROGRESS,
  REQUEST_REMOVE_OFFER_DOCUMENT_SUCCESS,
} from './types';

const updateMatchStatusmodalReducerObject = {
  [updateMatchStatus.request]: (state) =>
    state.setIn(['updateMatchStatusModal', 'network', 'loading'], true),
  [updateMatchStatus.success]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['updateMatchStatusModal', 'network', 'loading'], false)
        .setIn(['updateMatchStatusModal', 'network', 'error'], false)
        .setIn(['updateMatchStatusModal', 'network', 'success'], true),
    ),
  [updateMatchStatus.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['updateMatchStatusModal', 'network', 'loading'], false)
        .setIn(['updateMatchStatusModal', 'network', 'error'], action.error)
        .setIn(['updateMatchStatusModal', 'network', 'success'], false),
    ),
  [OPEN_UPDATE_MATCH_STATUS_MODAL]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['updateMatchStatusModal', 'isOpen'], true)
        .setIn(['updateMatchStatusModal', 'status'], action.status)
        .setIn(['updateMatchStatusModal', 'fundingMatchId'], action.fundingMatchId)
        .setIn(['updateMatchStatusModal', 'fundingSearchId'], action.fundingSearchId)
        .setIn(
          ['updateMatchStatusModal', 'network'],
          Map({
            loading: false,
            error: false,
            success: false,
          }),
        )
        .setIn(['updateMatchStatusModal', 'documents', 'files'], List()),
    ),
  [CLOSE_UPDATE_MATCH_STATUS_MODAL]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['updateMatchStatusModal', 'isOpen'], false)
        .setIn(['updateMatchStatusModal', 'fundingMatchId'], null)
        .setIn(['updateMatchStatusModal', 'fundingMatchId'], null)
        .setIn(['updateMatchStatusModal', 'documents'], Map({})),
    ),

  [REQUEST_OFFER_UPLOAD]: (state) =>
    state.withMutations((s) =>
      s
        .setIn(['updateMatchStatusModal', 'documents', 'loading'], true)
        .setIn(['updateMatchStatusModal', 'documents', 'progress'], 0),
    ),
  [REQUEST_OFFER_UPLOAD_SUCCESS]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['updateMatchStatusModal', 'documents', 'loading'], false)
        .setIn(['updateMatchStatusModal', 'documents', 'progress'], 0)
        .setIn(['updateMatchStatusModal', 'documents', 'success'], true)
        .setIn(['updateMatchStatusModal', 'documents', 'error'], false)
        .mergeIn(['updateMatchStatusModal', 'documents', 'files'], List(action.documents)),
    ),
  [REQUEST_OFFER_UPLOAD_FAILURE]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['updateMatchStatusModal', 'documents', 'loading'], false)
        .setIn(['updateMatchStatusModal', 'documents', 'progress'], 0)
        .setIn(['updateMatchStatusModal', 'documents', 'success'], false)
        .setIn(['updateMatchStatusModal', 'documents', 'error'], action.error),
    ),
  [REQUEST_OFFER_UPLOAD_PROGRESS]: (state, action) =>
    state.setIn(['updateMatchStatusModal', 'documents', 'progress'], action.progress),

  [REQUEST_REMOVE_OFFER_DOCUMENT_SUCCESS]: (state, action) =>
    state.updateIn(['updateMatchStatusModal', 'documents', 'files'], (files) =>
      files.filter((file) => file.id !== action.documentId),
    ),
};

export default updateMatchStatusmodalReducerObject;
